import { clientConfigurationApi } from '@texas/api/endpoints/clientConfigurationApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { createContextHookValue } from '@texas/utils/contextState';
import { useEffect } from 'react';

function useClientConfigurationContextValue() {
  const {
    data: clientConfiguration,
    error,
    loading,
    refetch,
  } = useApiResource(clientConfigurationApi.get);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    clientConfiguration,
    error,
    loading,
    isProduction:
      clientConfiguration === null ||
      clientConfiguration.hostEnvironment === 'Production',
  };
}

export const [ClientConfigurationProvider, useClientConfiguration] =
  createContextHookValue(useClientConfigurationContextValue);
